import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'frame', 'Frame', [["path",{"d":"M4 7l16 0"}],["path",{"d":"M4 17l16 0"}],["path",{"d":"M7 4l0 16"}],["path",{"d":"M17 4l0 16"}]]);